import React from 'react';
import { connect } from 'react-redux';
import {push} from "react-router-redux";
import {Link} from "react-router";
import { NotificationManager } from 'react-notifications';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {ROUTE_MEMBER, ROUTE_MEMBERS} from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";

import { nullToBlank } from '../../../../../common/src/util/lib';
import { confirm } from '../../../utils/confirmDialog';
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "../../reusable/UserFieldElement";

class MembersPage extends React.Component {

    static getId() {
        return ROUTE_MEMBERS;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            filter: '',
            showInactive: 0,
            sort: 'Medlemsnr',
            maxRows: 250,
        }
    }

    componentDidMount() {
        if (!this.props.admin.isMembersRead) this.props.dispatch(AdminActions.getMembers());
    }

    render() {
        return this.props.admin.isMembersRead ?
            <div>
                <div className="sub-page-title">
                    <h2>Medlemmer</h2>
                </div>
                <div className="sub-page-content">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th scope="row" className="clickable" onClick={() => {this.setState({sort: 'Medlemsnr'})}}>Nr</th>
                                <th className="clickable" onClick={() => {this.setState({sort: 'Foreningsnr'})}}>Foreningsnr.</th>
                                <th>Foreningsnavn</th>
                                <th className="clickable" onClick={() => {this.setState({sort: 'Fornavn'})}}>Fornavn</th>
                                <th className="clickable" onClick={() => {this.setState({sort: 'Efternavn'})}}>Efternavn</th>
                                <th className="clickable" onClick={() => {this.setState({sort: 'Postnr'})}}>Postnr.</th>
                                <th>Slag</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.admin.members
                                .filter(m => (
                                    this.state.showInactive || m.Foreningsnr != '999'
                                ) && (
                                    this.state.filter === '' ||
                                    nullToBlank(m.Efternavn).toUpperCase().search(this.state.filter) >= 0 ||
                                    nullToBlank(m.Fornavn).toUpperCase().search(this.state.filter) >= 0 ||
                                    nullToBlank(m.Medlemsnr).toUpperCase().search(this.state.filter) >= 0 ||
                                    nullToBlank(m[this.state.sort]).toUpperCase().search(this.state.filter) >= 0
                                ))
                                .sort((m1, m2) =>  {
                                    const comp = (m1[this.state.sort] === null ? '' : m1[this.state.sort].trim()).localeCompare(m2[this.state.sort] === null ? '' : m2[this.state.sort].trim(), 'da-DK');
                                    return comp === 0 ? (m1.Medlemsnr < m2.Medlemsnr ? -1 : 1) : comp;
                                }).toArray().map((member, ix) => {
                                    if (ix < this.state.maxRows) {
                                        const club = this.props.admin.clubs.get(member.Foreningsnr) || null;
                                        return <tr key={member.Medlemsnr} onDoubleClick={() => {
                                            this.props.dispatch(push(ROUTE_MEMBER.replace(':clubNo', member.Foreningsnr).replace(':memberNo', member.Medlemsnr).replace(':subpage', 'general').replace(':mode', 'view')));
                                        }}>
                                            <th scope="row">{member.Medlemsnr}</th>
                                            <td>{member.Foreningsnr}</td>
                                            <td>{club ? club.Navn : null}</td>
                                            <td>{member.Fornavn}</td>
                                            <td>{member.Efternavn}</td>
                                            <td>{member.Postnr}</td>
                                            <td>{member.Slagnr}</td>
                                            <td>
                                                <Link
                                                    to={ROUTE_MEMBER.replace(':clubNo', member.Foreningsnr).replace(':memberNo', member.Medlemsnr).replace(':subpage', 'general').replace(':mode', 'view')}
                                                    title="Vis detaljer">
                                                    <i className="fa fa-file-text-o"/>
                                                </Link>
                                                <Link
                                                    to={this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && this.props.auth.currentEntity === member.Foreningsnr) ? ROUTE_MEMBER.replace(':clubNo', member.Foreningsnr).replace(':memberNo', member.Medlemsnr).replace(':subpage', 'general').replace(':mode', 'edit') : ''}
                                                    className={this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && this.props.auth.currentEntity === member.Foreningsnr) ? '' : 'disabled'}
                                                    title="Rediger medlem">
                                                    <i className="fa fa-pencil"/>
                                                </Link>
                                                <i className={"fa fa-trash" + (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && this.props.auth.currentEntity === member.Foreningsnr) ? ' clickable' : ' disabled')}
                                                   title="Slet medlem" onClick={() => {
                                                    if (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && this.props.auth.currentEntity === member.Foreningsnr)) {
                                                        const fname = member.Fornavn === null ? '' : member.Fornavn;
                                                        const lname = member.Efternavn === null ? '' : member.Efternavn;
                                                        const name = fname + (fname !== '' && lname !== '' ? ' ' : '') + lname;
                                                        confirm("Slet",
                                                            <span>Ønsker du at slette medlem <b>{member.Medlemsnr + (name === '' ? '' : " (" + name + ")")}</b>?</span>, () => {
                                                                this.props.dispatch(AdminActions.deleteMember(member.Foreningsnr, member.Medlemsnr, () => {
                                                                    NotificationManager.success("Medlem " + member.Medlemsnr + (name === '' ? '' : " (" + name + ")") + " er slettet.", "Sletning", 4000);
                                                                }));
                                                            });
                                                    }
                                                }}/>
                                            </td>
                                        </tr>
                                    }
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className="sub-page-actions">
                    <Link className="btn-primary" to={ROUTE_MEMBER.replace(':clubNo', 'undefined').replace(':memberNo', 'new').replace(':subpage', 'general').replace(':mode', 'create')} title="Opret nyt medlem">
                        Ny
                    </Link>
                    <label htmlFor="filter">Filter</label>
                    <UserFieldElement dataType={UserFieldDataType.string} placeholder="Indtast søgeværdi" className="field-1 large-field"
                                      name="filter" id="filter"
                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                      onChange={(e) => {
                                          const val = e.target.value.toUpperCase();
                                          //this.onStandardFieldChange(e);
                                          if (this.timeoutHandler !== null) clearTimeout(this.timeoutHandler);
                                          this.timeoutHandler = setTimeout(() => {
                                              this.setState({filter: val});
                                          }, 500);
                                      }}
                    />
                    <input id="showInactive" name="showInactive" type="checkbox" checked={this.state.showInactive} onChange = {(e) => {
                        this.setState({showInactive: e.target.checked ? -1 : 0})
                    }}/>
                    <label htmlFor="showInactive">Vis inaktive</label>
                    <label htmlFor="sort">Sortering</label>
                    <UserFieldElement dataType={UserFieldDataType.enum} placeholder="false" className="field-1 large-field"
                                      name="sort" id="sort" value={this.state.sort} options={[
                                        {key: 'Medlemsnr', value: 'Medlemsnr'},
                                        {key: 'Fornavn', value: 'Fornavn'},
                                        {key: 'Efternavn', value: 'Efternavn'},
                                        {key: 'Foreningsnr', value: 'Foreningsnr'},
                                        {key: 'Postnr', value: 'Postnr'},
                                      ]}
                                      autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                      onChange={this.onStandardFieldChange}
                    />
                    <label htmlFor="maxRows">Antal rækker</label>
                    <UserFieldElement dataType={UserFieldDataType.string} placeholder={this.state.maxRows} className="field-1 medium-field"
                                      name="maxRows" id="maxRows"
                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                      onChange={(e) => {
                                          const val = e.target.value;
                                          //this.onStandardFieldChange(e);
                                          if (this.timeoutHandler !== null) clearTimeout(this.timeoutHandler);
                                          this.timeoutHandler = setTimeout(() => {
                                              if (/^[0-9]+$/.test(val)) this.setState({maxRows: Number(val)});
                                          }, 500);
                                      }}
                    />
                </div>
            </div> : null;
    }

    timeoutHandler = null;

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };
}

const mapStateToProps = (state) => ({
    auth: {
        isMainAdmin: state.auth.isMainAdmin,
        isSectionAdmin: state.auth.isSectionAdmin,
        isClubAdmin: state.auth.isClubAdmin,
        clubNumber: state.auth.clubNumber,
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        isClubsRead: state.admin.isClubsRead,
        clubs: state.admin.clubs,
        isMembersRead: state.admin.isMembersRead,
        members: state.admin.members,
    }
});

export default connect(mapStateToProps)(MembersPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/club/MembersPage.js